import './founders.component.js';
import './specialisms.component.js';
import './contact.component.js';
import './reviews.component.js';
import './form.component.js';
import './faq.component.js';
import './article.component.js';